module.exports = {
    /** Ger an array of length n filled with val
        * @param {number} n - desired length
        * @param {number} any - desired values
        */
    getPadding: (n, val) => {
        var arr = []
        for (let i = 0; i < n;i++) {
            arr.push(val)
        }
        return arr
    },
    /**
        * average of elements in an array
        * 
        * @param {array} values - input vector
    **/
    average: (values) => {
        return values.reduce((a, b) => a + b, 0) / values.length;
    },
    /**
        * minimum of elements in an array
        * 
        * @param {array} values - input vector
    **/
    min: (values) => {
        return values.reduce((a, b) => Math.min(a, b), Infinity);
    },
    /**
        * maximum of elements in an array
        * 
        * @param {array} values - input vector
    **/
    max: (values) => {
        return values.reduce((a, b) => Math.max(a, b), -Infinity);
    }
}